import { useState } from 'react'
import { BusinessLink, BusinessLinkType } from '@meniudigital/shared'
import { setBusinessLink } from 'src/state/users'

type InvalidFields = Partial<Record<BusinessLinkType, boolean>>

type UseBusinessLinksArgs = {
  user: { businessInfo?: BusinessLink[] } | null | undefined
  dispatch: (...args: any[]) => void
}

export function useBusinessLinks({ user, dispatch }: UseBusinessLinksArgs) {
  const [invalidFields, setInvalidFields] = useState<InvalidFields>({})

  const businessInfo: BusinessLink[] = user?.businessInfo || []

  const isBusinessInfoVisible = (mediumType: BusinessLinkType) =>
    businessInfo.some((link: BusinessLink) => link.type === mediumType && link.isVisible === true)

  const toggleBusinessMedium = (mediumType: BusinessLinkType) => {
    const currentSetting = businessInfo.find((link: BusinessLink) => link.type === mediumType)
    dispatch(setBusinessLink({ isVisible: !currentSetting?.isVisible, url: currentSetting?.url || '', type: mediumType }))
  }

  const updateBusinessMediumLinkUrl = (newUrl: string, mediumType: BusinessLinkType) => {
    const currentSetting = businessInfo.find((link: BusinessLink) => link.type === mediumType)
    dispatch(setBusinessLink({ isVisible: currentSetting?.isVisible || false, url: newUrl, type: mediumType }))
  }

  const isUrlInvalid = (type: BusinessLinkType) => {
    if (type === BusinessLinkType.PhoneNumber) {
      return false
    }

    const url = businessInfo.find((link: BusinessLink) => link.type === type)?.url

    if (!url) {
      return false
    }

    try {
      new URL(url)
      return false
    } catch (e) {
      return true
    }
  }

  const testValidity = (newUrl: string, mediumType: BusinessLinkType) => {
    if (!newUrl) {
      setInvalidFields(prev => ({ ...prev, [mediumType]: true }))
      return true
    }

    try {
      new URL(newUrl)
      setInvalidFields(prev => ({ ...prev, [mediumType]: false }))
      return false
    } catch (e) {
      setInvalidFields(prev => ({ ...prev, [mediumType]: true }))
      return true
    }
  }

  return {
    invalidFields,
    isBusinessInfoVisible,
    toggleBusinessMedium,
    updateBusinessMediumLinkUrl,
    isUrlInvalid,
    testValidity,
  }
}
